<div class="ui container" appMargin appPadding paddingB='30'>


    <div class='ui vertical basic segment' [ngClass]="{'loading':pending}">
        <div fxLayout="row" fxLayoutAlign='space-between center'>
            <div fxLayoutAlign='start center' fxLayout='row' fxLayoutGap='20px' (click)="goBack()" class="link">
                <div >
                    <img src="assets/icons/left-arrow-icon.svg" alt="">
                </div>
                <div class='equipment-id'>
					<!-- Title -->
                    <h2 class="ui primary header">{{role?.roleName}}</h2>
                </div>
            </div>

              <div fxLayout='row' fxLayoutGap='15px'>
                  		<button class="ui small  primary icon  button"  (click)="editRole()" suiPopup [popupInverted]="true" popupPlacement="bottom" popupText="edit role">
						<i class="ui pencil icon"></i>
						</button>

					<button class="ui basic small  primary  button" (click)="deleteRole()" suiPopup [popupInverted]="true" popupPlacement="bottom" popupText="delete role">
						Delete
						</button>

					<button class="ui small  primary  button" (click)="updateRolePermission()" suiPopup [popupInverted]="true" popupPlacement="bottom" popupText="edit role">
						Update
						</button>
					</div>

		</div>
		<div class="ui divider" appMargin marginY="3"></div>
    <div *ngIf="success || error">
      <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>

    </div>

		<div fxLayout="row" fxLayoutGap='50px'>
            <div fxFlex="25%">
				<div class="ui form side-panel" appPadding="15px">

					<div class="field" appMargin marginB="10">
						<label>TITLE</label>
						<h3 appMargin="0px" class="ui primary header">{{role?.roleName}}</h3>
					</div>
					<div class="field" appMargin marginB="10">
						<label>DESCRIPTION</label>
						{{role?.roleDescription}}
                    </div>
                    <div class="field" appMargin marginB="10">
						<label>DATE CREATED</label>
					{{role?.dateCreated?(role.dateCreated | date):'Nil'}}
                    </div>
                    		<div class="field" appMargin marginB="10">
						<label>CREATED BY</label>
					{{role?.createdBy?(role.createdBy):'Nil'}}
                    </div>
                    		<div class="field " appMargin marginB="10">
						<label>LAST EDITED</label>
							{{role?.dateModified?(role.dateModified | date):'Nil'}}
                    </div>
                    <div class="field" appMargin marginB="10">
						<label>EDITED BY</label>
					{{role?.modifiedBy?(role.modifiedBy):'Nil'}}
					</div>
                </div>
            </div>
				<div fxFlex="grow">
							<div class="ui   segment"  [ngClass]="{'loading':pending}">
								<div appPadding paddingB="15px">
                              <div fxLayout="row">
                        <div fxFlex="grow"></div>
                        <div fxFlex="10%">READ</div>
                         <div fxFlex="10%">CREATE</div>
                         <div fxFlex="10%">EDIT</div>
                         <div fxFlex="10%">DELETE</div>
                    </div>

                    <div class="ui divider"></div>


           <ng-template ngFor let-permission [ngForOf]="selectedRolePermissions" let-i="index">
                                <div fxLayout="column" *ngIf="permission.groupName && i == 0 " >
                                  <div>
                                   <strong> {{permission?.groupName | uppercase}} </strong>
                                  </div>
                                <div class="ui divider"></div>
                                </div>
                                     <div fxLayout="column" *ngIf="permission.groupName && i != 0 " appMargin marginT="15">
                                  <div>
                                   <strong> {{permission?.groupName | uppercase}} </strong>
                                  </div>
                                <div class="ui divider"></div>
                                </div>
                                <div fxLayout="row" *ngFor="let perm of permission.permissions" appMargin marginB="7">
                                  <div fxFlex="grow">
                                    {{perm?.permissionDesc}}
                                  </div>

                                  <div fxFlex="10%" >
                                      <!-- <sui-checkbox
                                      [(ngModel)]="perm.read" >
                                       </sui-checkbox> -->
                                    <!-- <input  [checked]="perm.read === checkOptions[0].value" [value]="perm.read"
                                      name="read" type="checkbox"> -->
                                         <sui-checkbox
                                            [ngModel]="perm.read === checkOptions[0].value"
                                            [isDisabled]="perm.read === 'disabled'"
                                            (checkChange)="$event? (perm.read = checkOptions[0].value) : (perm.read = checkOptions[1].value)"
                                            >
                                        </sui-checkbox>
                                  </div>

                                  <div fxFlex="10%"  >
                                    <!-- <input  [checked]="perm.add === checkOptions[0].value" [value]="perm.add"
                                      name="add" type="checkbox"> -->
                                                   <sui-checkbox
                                            [ngModel]="perm.add === checkOptions[0].value"
                                            [isDisabled]="perm.add === 'disabled'"
                                            (checkChange)="$event? (perm.add = checkOptions[0].value) : (perm.add = checkOptions[1].value)"
                                            >
                                        </sui-checkbox>
                                  </div>

                                  <div fxFlex="10%"  >
                                    <!-- <input  [checked]="perm.edit === checkOptions[0].value" [value]="perm.edit"
                                      name="edit" type="checkbox" > -->
                                                   <sui-checkbox
                                            [ngModel]="perm.edit === checkOptions[0].value"
                                            [isDisabled]="perm.edit === 'disabled'"
                                            (checkChange)="$event? (perm.edit = checkOptions[0].value) : (perm.edit = checkOptions[1].value)"
                                            >
                                        </sui-checkbox>
                                  </div>

                                  <div fxFlex="10%"  >
                                    <!-- <input [checked]="perm.remove === checkOptions[0].value" [value]="perm.remove"
                                      name="remove" type="checkbox"> -->
                                                   <sui-checkbox
                                            [ngModel]="perm.remove === checkOptions[0].value"
                                            [isDisabled]="perm.remove == 'disabled'"
                                            (checkChange)="$event? (perm.remove = checkOptions[0].value) : (perm.remove = checkOptions[1].value)"
                                            >
                                        </sui-checkbox>
                                  </div>
                                </div>
                            </ng-template>
		</div>

						</div>

				</div>
			</div>

</div>
